import React, {useMemo} from 'react';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import ProgramGroupMessage from '../ProgramGroupMessage/ProgramGroupMessage';
import {hasMoreSelectableSessions} from './hasMoreSelectableSessions';

function AditionalSelectionAvailableMessage(props) {
    const {event, items, onClick} = props,
        currentSelection = useMemo(() => items.filter(session => session.is_selectable && session.is_selected), [items]),
        unselectedItems = useMemo(() => items.filter(session => session.is_selectable && !session.is_selected), [items]),
        hasSelectableUnselectedSessions = useMemo(() => hasMoreSelectableSessions(currentSelection, unselectedItems), [items]),
        i18n = useI18n();

    if (!currentSelection.length) return null;
    if (!hasSelectableUnselectedSessions) return null;

    return <ProgramGroupMessage event={event} onClick={onClick}>{i18n['label.additional-session']}</ProgramGroupMessage>;
}

export default AditionalSelectionAvailableMessage;
